module.exports = __webpack_public_path__ + "static/media/unnamed@3x.9af657b3.jpg";